export const errorType = {
    AUTH04: "AUTH-04",
};